export const buildNumber = '20260416.5';
export const version = 'main';
export const latestCommit = '0025a649b1c221be44fc37765fa2dba1cf1a845d';
